import React from 'react';

export default function VisaIcon() {
  return (
    <svg
      width="36px"
      height="12px"
      viewBox="0 0 36 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="🐵---UI-Nat---Desktop"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="05a" transform="translate(-198.000000, -437.000000)">
          <g id="Group-5" transform="translate(132.000000, 260.000000)">
            <g id="Group-7" transform="translate(40.000000, 111.000000)">
              <g id="Message/Warning">
                <g id="Group-9">
                  <g id="Group-3" transform="translate(0.000000, 39.000000)">
                    <g id="visa" transform="translate(15.000000, 15.000000)">
                      <g
                        id="logo-visa"
                        transform="translate(11.000000, 12.000000)"
                      >
                        <polygon
                          id="polygon9"
                          fill="#00579F"
                          points="15.563736 11.7805644 12.6676223 11.7805644 14.4790593 0.353036998 17.3750146 0.353036998"
                        />
                        <path
                          d="M26.0624054,0.632407437 C25.4911645,0.4011876 24.5851293,0.145892462 23.4648193,0.145892462 C20.604814,0.145892462 18.5908217,1.70190017 18.5784688,3.92652261 C18.5547133,5.56784414 20.0204284,6.47947399 21.1166661,7.02674275 C22.2371344,7.58596836 22.6180145,7.95097578 22.6180145,8.44944761 C22.6066118,9.21500987 21.7126127,9.56789884 20.8787943,9.56789884 C19.7225343,9.56789884 19.1029905,9.38596066 18.1614804,8.96003789 L17.7801253,8.77745339 L17.3748562,11.3426848 C18.0541055,11.6584105 19.3055459,11.9385889 20.604814,11.9508689 C23.6436191,11.9508689 25.6219782,10.4189365 25.645417,8.04824646 C25.656978,6.74737231 24.8830234,5.75059021 23.2144362,4.93606946 C22.2015012,4.41319917 21.5811656,4.06063335 21.5811656,3.52564461 C21.5930433,3.03929122 22.1058457,2.54114254 23.2492776,2.54114254 C24.1907878,2.51674408 24.8825483,2.74764076 25.4065949,2.97869902 L25.668539,3.100045 L26.0624054,0.632407437 Z"
                          id="path11"
                          fill="#00579F"
                        />
                        <path
                          d="M29.9115902,7.73219754 C30.1500955,7.07570124 31.0678502,4.5348683 31.0678502,4.5348683 C31.055814,4.55926676 31.3058804,3.86625357 31.4488886,3.44081553 L31.6512855,4.42547919 C31.6512855,4.42547919 32.1997211,7.16085348 32.3188154,7.73219754 C31.8661937,7.73219754 30.4836229,7.73219754 29.9115902,7.73219754 Z M33.486478,0.353036998 L31.2463332,0.353036998 C30.555523,0.353036998 30.0306845,0.559535217 29.732632,1.30118375 L25.4308255,11.7804028 L28.4696306,11.7804028 C28.4696306,11.7804028 28.9699217,10.369978 29.077455,10.0662091 C29.410824,10.0662091 32.3669599,10.0662091 32.7958261,10.0662091 C32.8789704,10.4674103 33.1413896,11.7804028 33.1413896,11.7804028 L35.8229118,11.7804028 L33.486478,0.353036998 Z"
                          id="path13"
                          fill="#00579F"
                          fillRule="nonzero"
                        />
                        <path
                          d="M10.2486777,0.353036998 L7.4124279,8.14551713 L7.10249765,6.56511097 C6.57813432,4.7415281 4.93361939,2.76024394 3.0984269,1.77509555 L5.6963297,11.768446 L8.75889033,11.768446 L13.3110799,0.353036998 L10.2486777,0.353036998 Z"
                          id="path15"
                          fill="#00579F"
                        />
                        <path
                          d="M4.77873345,0.353036998 L0.119168931,0.353036998 L0.0714995363,0.583933676 C3.70625127,1.53224201 6.1134765,3.81810297 7.10249765,6.56559571 L6.08956262,1.31362535 C5.92279892,0.583772097 5.41031334,0.377112299 4.77873345,0.353036998 Z"
                          id="path17"
                          fill="#FAA61A"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
